import { linkInsightRecords, linkInteraction } from "@redux/index";
import { useRef, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { linkRecordsOnMap } from "features/journey-map/reducer/CJMActions";
import { InsightDropdown } from "shared/dropdowns/cx-dropdown/Insights/InsightDropdown";
import { Button, IconDispatcher } from "shared/ui-basics";
import styled from "styled-components";
import { InformationType } from "utils/optionsSets/OptionSets";
import { v4 as uuid } from "uuid";
import { getStage } from "redux/memoizedSelectors";
import $ from "jquery";
export const AddInsight = ({ swimlaneKey, stageId, interaction, selected, disableAI = false }) => {
	const { t } = useTranslation();

	const { cjmIdStr, personaIdStr } = useLocation().search.getAllMapsParams();

	const cjmSwimLaneDetails = useSelector((state) => state.maps.current_map.cjmSwimLaneDetails?.[swimlaneKey]?.[stageId]);
	const [show, setShow] = useState(false);
	const stageName = useSelector(getStage(stageId))?.name;

	const handleToggle = (isOpen) => {
		setShow(isOpen);
		const selector = $(`#addItems_${swimlaneKey}_${stageId}`);
		if (isOpen && selector) {
			selector.addClass("open");
		} else if (selector) {
			selector.removeClass("open");
		}
	};

	const handleClose = () => setShow(false);

	const linkedInsights = selected ? selected : cjmSwimLaneDetails?.items.map((item) => item?.insightId);

	const linkInsightOnMapWrapper = (recordId, onSuccess) => {
		const isArray = Array.isArray(recordId);

		if (stageId) {
			const params = {
				cjmId: cjmIdStr,
				customSwimLaneId: swimlaneKey,
				stageId,
				swimLaneItemIds: isArray ? recordId.map((d) => uuid()) : [uuid()],
				objIds: isArray ? recordId : [recordId],
				objType: InformationType.Insights,
				attributeId: "insightId",
				personaId: personaIdStr,
				onSuccess,
			};
			linkRecordsOnMap(params);
		}
	};

	const handleLink = (id, onLinkSuccess) => {
		if (interaction) {
			// link insight to the interaction
			linkInteraction({
				recEntityName: "cem_insight",
				recIds: [id],
				itemId: interaction?.id,
				stageId,
				attribute: "linkedInsights",
			});
			// Link touchpoint in insight
			linkInsightRecords({ itemId: id, recIds: [interaction?.channelId], recEntityName: "cem_touchpoints", attribute: "linkedTouchpoints" });
		}
		linkInsightOnMapWrapper(id, onLinkSuccess);
		if (show) handleToggle(false);
	};

	return (
		<DropDownContainer show={show} onToggle={handleToggle}>
			<Dropdown.Toggle id="add-list" as={Button} variant="light-link">
				<ActionContainer>
					<div className="me-2">{IconDispatcher("PLUS")}</div>
					<div>{t("ADD_INSIGHT")}</div>
				</ActionContainer>
			</Dropdown.Toggle>
			<MenuContainer key={show}>
				<InsightDropdown
					selected={linkedInsights}
					link={handleLink}
					isOpen={true}
					showShadow={true}
					closeDropdown={handleClose}
					globalWidth="576px"
					aiParameters={
						disableAI
							? null
							: {
									stageId,
									stageName,
									swimlaneKey,
							}
					}
				/>
			</MenuContainer>
		</DropDownContainer>
	);
};

const DropDownContainer = styled(Dropdown)`
	.dropdown-toggle::after {
		display: none;
	}
	.dropdown-menu {
		padding: 0px;
		margin: 0px;
	}
`;

const MenuContainer = styled(Dropdown.Menu)`
	width: 576px;
	max-height: 292px;
	border: none;
`;

const ActionContainer = styled.div`
	display: flex;
	align-items: center;
	line-height: 24px;
	font-size: 14px;
	background-color: transparent !important;
	color: #605f60 !important;
`;
